import React from 'react';

export const Exit: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M4.65 3.01L4.7 3h8.12a2.26 2.26 0 012.27 2.25V6a.76.76 0 01-1.5 0v-.75a.75.75 0 00-.77-.75H9.3l.23.08A1.5 1.5 0 0110.56 6v11.25h2.27a.75.75 0 00.75-.75V15a.76.76 0 011.51 0v1.5a2.26 2.26 0 01-2.26 2.25h-2.27v.75A1.5 1.5 0 019.05 21a1.6 1.6 0 01-.49-.07l-4.54-1.5A1.5 1.5 0 013 18V4.5a1.51 1.51 0 011.65-1.49zm0 0"
    />
    <path
      fill="currentColor"
      d="M12.9 9.97l3.03-3.02a.76.76 0 011.29.54v2.26h3.02a.76.76 0 010 1.52h-3.02v2.26a.76.76 0 01-1.29.54l-3.02-3.03a.76.76 0 010-1.07zm0 0"
    />
  </svg>
);
